import { mergeRequestInits } from './fetcher/fetcher';
export function requestInitWithDefaultIfMatch(init) {
    const headers = new Headers(init.headers);
    headers.set('content-type', 'text/plain');
    if (!headers.has('If-Match') && !headers.has('If-None-Match')) {
        headers.set('If-Match', '*');
    }
    return mergeRequestInits(init, { headers });
}
//# sourceMappingURL=requestInitWithDefaultIfMatch.js.map